import { jsx as _jsx } from "react/jsx-runtime";
import { CurrentPatientProvider, InsulinReminderProvider, Spinner, } from "@madmedical/ui";
import { adaptPatient, usePatient } from "@madmedical/user";
import { invariant } from "@madmedical/utils";
import { useGetInsulinRemindersQuery } from "../api";
import adaptInsulinReminders from "../adaptInsulinReminders";
const InsulinReminderProviders = ({ children }) => {
    var _a;
    const { patientId, patient, isLoading: isPatientLoading } = usePatient();
    const { data: insulinReminders, isLoading: isReminderLoading } = useGetInsulinRemindersQuery({
        patientId,
    });
    if (isPatientLoading || isReminderLoading) {
        return _jsx(Spinner, {});
    }
    invariant(patient);
    invariant(insulinReminders);
    return (_jsx(InsulinReminderProvider, Object.assign({ value: {
            reminders: (_a = insulinReminders === null || insulinReminders === void 0 ? void 0 : insulinReminders.map(adaptInsulinReminders)) !== null && _a !== void 0 ? _a : [],
        } }, { children: _jsx(CurrentPatientProvider, Object.assign({ value: { patient: adaptPatient(patient) } }, { children: children })) })));
};
export default InsulinReminderProviders;
